



























import BaseComponent from "./BaseComponent.vue";
import { Focus } from '../directives/focus';
import { Vue, Component, Watch } from "vue-property-decorator";
import { WampProcedures } from '../lib/Controller/WampClient';
import { SessionState } from '../lib/Controller/State';
import { QForm } from 'quasar';
import _ from 'lodash';
import { Constants } from "../lib/Controller/Actions";
import ConstantStrings from '../lib/constants/strings';
import Paths from '../lib/constants/paths';

@Component
export default class PageNotFound extends Vue {
	Paths = Paths;
	ConstantStrings = ConstantStrings;
	currentYear = (new Date()).getFullYear();
	IAVersion:string = '';

	mounted() {
		this.$q.dark.set(true);
		if(!_.isEmpty((window as any).IAVersion)){
			this.IAVersion = 'Version ' + (window as any).IAVersion;
		}
	}
}
